<template>
  <div id="user">
    <div class="py-2" style="position: relative">
      <v-list-tile avatar class="px-0">
        <v-list-tile-avatar>
          <template v-if="user.profile_pic">
            <img class="profile" :src="user.profile_pic" alt @error="imgError(this)" />
          </template>
          <template v-else>
            <img class="profile" src="/static/img/assets/livechat/profile.png" alt />
          </template>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title
            :style="$vuetify.breakpoint.mdAndUp && `font-size: 13px`"
            :class="{ unreadmessage: !user.adminread }"
            >{{ user.first_name }} {{ user.last_name }}
          </v-list-tile-title>
          <v-list-tile-sub-title
            class="caption"
            :class="{
              unreadmessage: !user.adminread
            }"
          >
            {{ user.lastmessage | fmMessage }}
          </v-list-tile-sub-title>

          <v-list-tile-sub-title class="caption col-6" :class="{ unreadmessage: !user.adminread }">
            {{ dayLeft(user.lastreply_time) }}
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <div
        v-if="
          user.tickets &&
          user.tickets.length > 0 &&
          user.tickets[0][2].toLowerCase() !== 'closed' &&
          user.tickets[0][2].toLowerCase() !== 'cancelled' &&
          user.tickets[0][2].toLowerCase() !== 'cancelled by customer'
        "
        class="text-xs-right"
        style="position: absolute; right: 0px; bottom: 5px; z-index: 1"
      >
        <v-chip
          @click="showEditTicketStatus"
          small
          :color="ticketColorStatus(user.tickets[0][2])"
          dark
          class="caption"
        >
          <span class="pr-1">{{ user.tickets[0][2] }}</span>
          <em class="fas fa-chevron-down" />
        </v-chip>
      </div>
      <div v-else class="text-xs-right" style="position: absolute; right: 0px; bottom: 5px">
        <edit-ticket
          :type="'add'"
          @addTicket="onAddTicket"
          :loading="loading"
          :isquickaddticket="true"
          v-model="user"
        ></edit-ticket>
      </div>
    </div>
    <v-divider></v-divider>
    <div>
      <v-dialog
        content-class="nooverflow"
        class="dialog-nooverflow"
        v-model="ticketModal"
        width="400px"
        persistent
        style="overflow-y: none !important"
      >
        <v-card class="pa-3">
          <div class="mb-3" style="font-size: 21px; font-weight: 600">Change status</div>
          <div>
            <multiselect
              v-model="ticketStatus"
              tag-placeholder="Add this as new tag"
              placeholder="Status"
              :searchable="false"
              :options="optionsStatus"
              :show-labels="false"
            ></multiselect>
          </div>
          <div class="text-xs-center mt-2">
            <v-btn @click="ticketModal = false" outline color="grey">Cancel</v-btn>
            <v-btn :loading="saveloading" @click="saveTicketStatus" depressed color="primary"
              >Save</v-btn
            >
          </div>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import axios from 'axios'
import config from '@/config'
import { mapGetters } from 'vuex'
import moment from 'moment'
const EditTicket = () => import('@/components/view/template/ticket/EditTicket.vue')
import Multiselect from 'vue-multiselect'

export default {
  props: ['value'],
  components: {
    EditTicket,
    Multiselect
  },
  data() {
    return {
      limit: 10,
      offset: 0,
      user: {},
      loading: false,
      ticketStatus: null,
      groups: {},
      subgroups: {},
      ticketModal: false,
      optionsStatus: ['Pending', 'Answered', 'Closed', 'Cancelled', 'Cancelled by customer'],
      saveloading: false
    }
  },
  async mounted() {
    if (this.value) {
      this.user = this.value
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {
    dayLeft: function (replytime) {
      var lastreply = moment(replytime)
      var currentDate = moment()

      var time = ''
      if (currentDate.diff(lastreply, 'days') > 0) {
        time = lastreply.format('DD MMM YYYY')
      } else if (currentDate.diff(lastreply, 'hours') > 0) {
        time = currentDate.diff(lastreply, 'hours')
        time += ' ' + this.$t('Hours')
      } else if (currentDate.diff(lastreply, 'minutes') > 0) {
        time = currentDate.diff(lastreply, 'minutes')
        time += ' ' + this.$t('Minutes')
      } else if (currentDate.diff(lastreply, 'seconds') > 0) {
        time = currentDate.diff(lastreply, 'seconds')
        time += ' ' + this.$t('Seconds')
      }
      return time
    },
    showEditTicketStatus() {
      this.ticketStatus = this.user.tickets[0][2]
      this.ticketModal = true
    },
    saveTicketStatus() {
      var data = {
        pageid: this.selectedBot.pageid,
        status: this.ticketStatus.toLowerCase(),
        ticketId: this.user.tickets[0][0]
      }
      this.saveloading = true
      api.postRabbitUpdateTicket(data, (err, response) => {
        this.saveloading = false
        this.user.tickets[0][2] = this.ticketStatus
        this.ticketModal = false
      })
    },
    ticketColorStatus(val) {
      switch (val.trim().toLowerCase()) {
        case 'pending':
          return '#fb8c00'
        case 'closed':
          return '#e0e0e0'
        case 'cancelled':
          return '#ff5252'
        case 'cancelled by customer':
          return '#fd87ee'
        case 'answered':
          return '#2196f3'
        case 'open':
          return '#4CAF50'
        default:
          return ''
      }
    },
    async onAddTicket(payload) {
      this.user.tickets[0][2] = payload.status
      this.ticketStatus = payload.status
    },
    getAdminGroup() {
      var data = {
        pageid: this.selectedBot.pageid
      }
      return new Promise((resolve, reject) => {
        api.getAdminGroup(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    },
    getAdminSubGroup() {
      var data = {
        pageid: this.selectedBot.pageid
      }
      return new Promise((resolve, reject) => {
        api.getAdminSubGroup(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    },
    imgError: function (event, el) {
      this.value.profile_pic = '/static/img/assets/livechat/profile.png'
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      this.loading = true
      this.user = newVal
      if (Object.keys(user).length > 0) {
        this.loading = false
      }
    },
    selected: function (newVal, oldVal) {}
  },
  filters: {
    fmMessage(value) {
      if (value && value.startsWith('data:image')) {
        return 'image'
      } else {
        return value
      }
    }
  }
}
</script>

<style lang="scss">
.px-0 .v-list__tile {
  padding-left: 5px !important;
  padding-right: 2px !important;
}
.unreadmessage {
  color: black !important;
  font-weight: bold;
}
.v-chip__content {
  cursor: pointer !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/RabbitReplyFBPost/ReplyCommentUserItem.vue